__turbopack_context__.v({
  "active": "style-module__gfybKa__active",
  "label": "style-module__gfybKa__label",
  "toggle": "style-module__gfybKa__toggle",
  "toggleButton": "style-module__gfybKa__toggleButton",
  "toggleContainer": "style-module__gfybKa__toggleContainer",
});
